import { mapConstants } from '../constant/map'


export default function map(state = {}, action) {
  switch (action.type) {

    case mapConstants.READ_MAPS_SUCCESS:
      return { ...state, totalCount: action.resp.totalCount }

    // case mapConstants.READ_MAPS_SUCCESS:
    //   return { ...state, readAll: action.resp, isReady: true }

    // case mapConstants.READ_MAPS_FAILURE:
    //   return { ...state, isReady: true }

    default:
      return state
  }
}